import React from "react";
import { Col, Card, CardBody, Spinner, Button } from "reactstrap";
import { Link } from "react-router-dom";
import { MdArrowBack } from "react-icons/md";
import AccessControl from "../../../../shared/components/AccessControl";
import { permissionsConstants } from "../../../../constants/permissions.constants";

const ViewMapping = ({ mapping, domainCode, fetchData }) => {
    const foundMapping = mapping.response && mapping.response.data && mapping.response.data.length && !mapping.loading;
    const mappingObject = mapping.response && mapping.response.data && mapping.response.data.length ? mapping.response.data[0] : {};

    return (
        <Col>
            <Card>
                <CardBody>
                    {foundMapping ? (
                        <div className="project-summary">
                            <div className="card__title">
                                <h4 className="bold-text">Mapping for {mappingObject.domainCode}</h4>
                            </div>
                            <AccessControl allowedPermissions={[permissionsConstants.UPDATE_ISSUER_MAPPING]} renderNoAccess={() => null}>
                                <Link to={`/issuer-mapping/edit/${domainCode}`} className="btn btn-sm btn-outline-secondary project-summary__btn" id="link-edit-mapping">
                                    Edit
                                </Link>
                            </AccessControl>

                            <dl className="row">
                                <dt className="col-sm-2">Issuer</dt>
                                <dd className="col-sm-10">
                                    <p>
                                        {mappingObject.issuerName} ({mappingObject.issuerCode})
                                    </p>
                                </dd>
                                <dt className="col-sm-2">Issuer Number</dt>
                                <dd className="col-sm-10">
                                    <p>{mappingObject.issuerNr}</p>
                                </dd>
                                <dt className="col-sm-2">Bank Code</dt>
                                <dd className="col-sm-10">
                                    <p>{mappingObject.bankCode}</p>
                                </dd>
                                <dt className="col-sm-2">Report Issuer</dt>
                                <dd className="col-sm-10">
                                    <p>{mappingObject && mappingObject.reportPrefix ? mappingObject.reportPrefix : null}</p>
                                </dd>
                            </dl>
                        </div>
                    ) : (
                        <div className="text-center">
                            {mapping && mapping.loading ? (
                                <div>
                                    <Spinner color="success" className="my-4" style={{ width: "6rem", height: "6rem" }} />
                                    <h4 className="text-secondary">Fetching issuer mapping for domain code ({domainCode})</h4>
                                </div>
                            ) : (
                                <div>
                                    <h4 className="text-danger">{mapping.error ? `Something went wrong. Could not fetch issuer mapping for (${domainCode})` : `Domain code: (${domainCode}) not found`}</h4>
                                    <Button color="primary" id="btn-try-again" outline size="sm" onClick={fetchData}>
                                        Try Again
                                    </Button>
                                </div>
                            )}
                        </div>
                    )}
                    {mapping && !mapping.loading ? (
                        <h5 className="bold-text mt-4">
                            <Link to="/issuer-mapping" id="link-all-mappings">
                                <MdArrowBack size={20} /> Back to Mappings
                            </Link>
                        </h5>
                    ) : null}
                </CardBody>
            </Card>
        </Col>
    );
};

export default ViewMapping;
